import { wrapApiCall } from '@/lib/axios'
import type { AxiosInstance } from 'axios'
import { deserialize } from 'ts-jackson'
import {
  RenewalAlertSettings,
  RenewalMembersPage,
  RenewalMembersQuery,
  RenewalSalesKpi,
  RenewalSummary,
  RenewalTimeline,
  RenewalTimelineView,
  UpdateRenewalAlertSettingsPayload,
} from './model'

export const RenewalForecastService = (client: AxiosInstance) => {
  return {
    async getSummary(opt: { branchId?: number } = {}): Promise<RenewalSummary> {
      const { data } = await wrapApiCall(() =>
        client.get<{ data: Record<string, unknown> }>('/renewal-forecast/summary', { params: opt })
      )
      return deserialize(data?.data ?? {}, RenewalSummary)
    },
    async getTimeline(opt: {
      view: RenewalTimelineView
      branchId?: number
    }): Promise<RenewalTimeline> {
      const { data } = await wrapApiCall(() =>
        client.get<{ data: Record<string, unknown> }>('/renewal-forecast/timeline', { params: opt })
      )
      return deserialize(data?.data ?? {}, RenewalTimeline)
    },
    async getMembers(opt: RenewalMembersQuery = {}): Promise<RenewalMembersPage> {
      const { data } = await wrapApiCall(() =>
        client.get<{ data: Record<string, unknown> }>('/renewal-forecast/members', { params: opt })
      )
      return deserialize(data?.data ?? {}, RenewalMembersPage)
    },
    async getSalesKpi(opt: { branchId?: number } = {}): Promise<RenewalSalesKpi[]> {
      const { data } = await wrapApiCall(() =>
        client.get<{ data: Record<string, unknown>[] }>('/renewal-forecast/sales-kpi', {
          params: opt,
        })
      )
      const list = data?.data ?? []
      return list.map((row) => deserialize(row, RenewalSalesKpi))
    },
    async getAlertSettings(opt: { branchId?: number } = {}): Promise<RenewalAlertSettings> {
      const { data } = await wrapApiCall(() =>
        client.get<{ data: Record<string, unknown> }>('/renewal-forecast/alert-settings', {
          params: opt,
        })
      )
      return deserialize(data?.data ?? {}, RenewalAlertSettings)
    },
    async updateAlertSettings(
      payload: UpdateRenewalAlertSettingsPayload
    ): Promise<{ message: string }> {
      const { data } = await wrapApiCall(() =>
        client.put<{ message?: string }>('/renewal-forecast/alert-settings', payload)
      )
      return { message: data?.message ?? '' }
    },
  }
}
